import { dialogService } from "react-api-dialog";
import { LoginWithAnalytics } from "../auth";

export function delay(millisecond: number) {
    return new Promise((resolve: any, reject: any) => {
        setTimeout(() => {
            resolve();
        }, millisecond);
    });
}
export function authHook2(target: object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
        const result = originalMethod.apply(this, args);
        return result;
    }
}
export function authHook(target: object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
        const result = originalMethod.apply(this, args);
        if (result instanceof Promise) {
            return result.catch(e => {
                if (e.response && (e.response.status === 401 || e.response.headers.status === 401 || e.response.headers.status === 403 || e.response.status === 403)) {
                    return dialogService.showComponent(LoginWithAnalytics, { hash: "auth", path: "/login", animation: "slide-down", style: { bottom: 0, right: 0 }, showCloseButton: true }).then(authResponse => {
                        if (authResponse.cancelled) {
                            return undefined;
                        } else {
                            const result2 = originalMethod.apply(this, args);
                            return result2;
                        }
                    })
                } else {
                    return result;
                }
            })
        } else {
            return result;
        }
    }
}

export function showLogin() {
    return dialogService.showComponent(LoginWithAnalytics, { hash: "auth", path: "/login", animation: "slide-down", style: { bottom: 0, right: 0 }, showCloseButton: true }, { showGuestCheckout: "true" });
}

export function fetchGuestEmail() {
    const guestEmail = window.sessionStorage.getItem("guest-email");
    return guestEmail;
}

export function setGuestEmail(email: string) {
    window.sessionStorage.setItem("guest-email", email);
}
export function removeGuestEmail() {
    window.sessionStorage.removeItem("guest-email");
}